module.exports = __webpack_public_path__ + "img/responsible-consumption-and-production.e13c3f4f.png";